import { InMemoryCache, ApolloLink, CombinedGraphQLErrors, CombinedProtocolErrors } from '@apollo/client/core';
import { ErrorLink } from '@apollo/client/link/error';
import { HttpLink } from 'apollo-angular/http';
import { SetContextLink } from '@apollo/client/link/context';
import { RetryLink } from '@apollo/client/link/retry';
import { environment } from 'environments/environment';
import { inject } from '@angular/core';

export function apolloInitializerNotifications() {

  const httpLink = inject(HttpLink)
  const authLink = new SetContextLink((prevContext, operation) => ({credentials: "include"}));

  const retryLink = new RetryLink({
    attempts: {
      max: 10,
      retryIf: (error) => !!error,
    },
    delay: {
      initial: 30000,
      max: 30000,
      jitter: false,
    },
  });
  
  const httpNotifications = httpLink.create({ uri: environment.graphql_notifications });
  const errorLink = new ErrorLink(({ error, operation }) => {
    if (CombinedGraphQLErrors.is(error)) {
      error.errors.forEach(({ message, locations, path }) =>
        console.error(`[GraphQL error API Notifications]: Message: "${message}", Operation: ${operation}, Path: ${path}, Locations: ${locations}`),
      );
    } else if (CombinedProtocolErrors.is(error)) {
      error.errors.forEach(({ message, extensions }) =>
        console.error(`[GraphQL error API Notifications]: Message: "${message}", Extensions: ${JSON.stringify(extensions)}`),
      );
    } else {
      console.error(`[Network error API Notifications]: ${error.name}`);
    }
  });

  return {
    notifications_http: {
      link: ApolloLink.from([errorLink, retryLink, authLink.concat(httpNotifications)]),
      cache: new InMemoryCache(),
    },
  };
}